import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function durationToMins(duration?: string | null): string {
  if (!duration) return "";
  const cleaned = duration.trim();
  if (/mins?/i.test(cleaned)) return cleaned.toUpperCase();
  const parts = cleaned.split(":").map((p) => Number(p));
  if (parts.some((n) => Number.isNaN(n))) return cleaned.toUpperCase();
  if (parts.length === 3) return `${parts[0] * 60 + parts[1]} MINS`;
  if (parts.length === 2) return `${parts[0]} MINS`;
  return cleaned.toUpperCase();
}

export function formatPublishedLabel(date?: string | Date | null): string {
  if (!date) return "";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  const diff = Date.now() - d.getTime();
  const minutes = Math.max(0, Math.floor(diff / 60000));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  if (minutes < 60) return "PUBLICADO HACE UN MOMENTO";
  if (hours < 24) return `PUBLICADO HACE ${hours} HORA${hours === 1 ? "" : "S"}`;
  if (days < 30) return `PUBLICADO HACE ${days} DÍA${days === 1 ? "" : "S"}`;
  const months = Math.floor(days / 30);
  if (months < 12) return `PUBLICADO HACE ${months} MES${months === 1 ? "" : "ES"}`;
  const years = Math.floor(months / 12);
  return `PUBLICADO HACE ${years} AÑO${years === 1 ? "" : "S"}`;
}

export function formatLongDate(date?: string | Date | null): string {
  const d = date ? new Date(date) : new Date();
  if (Number.isNaN(d.getTime())) return "";
  return d
    .toLocaleDateString("es-ES", {
      weekday: "long",
      month: "long",
      day: "numeric",
    })
    .toUpperCase();
}
